import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetOrderService } from '../../services/asset-order.service';
import { Router } from '@angular/router';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { AssetOrder } from '../../models/entities/asset-order';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetOrderLine } from '../../models/entities/asset-order-line';
import { AssetTransferDirection } from '../../enums/asset-transfer-direction';
import { AssetTransferType } from '../../enums/asset-transfer-type';


@Component({
    selector: 'asset-order-widget-mobile',
    templateUrl: './asset-order-widget-mobile.component.html',
    styleUrls: ['./asset-order-widget-mobile.component.scss']
})

export class AssetOrderWidgetMobileComponent extends BaseWidget {
  
  @Input() assetOrder       : AssetOrder;
//  @Input() assetOrderCode   : string;
  assetOrderLineColumns     = [];
  receptionMode             : boolean = false;

  constructor(
    protected assetOrderService   : AssetOrderService,
    protected toastr              : ToastrService,
    protected router              : Router,
    public leanUtilsService    : LeanUtilsService) {
    super(toastr, leanUtilsService);
 }


ngOnInit(){
      super.ngOnInit();

    this.assetOrderService.assetOrderGet(this.assetOrder.assetOrderCode).then(result => {
      this.assetOrder = result;
      for (let assetOrderLine of this.assetOrder.assetOrderLines){
        assetOrderLine.serialNumbers = [];
        assetOrderLine.shrinkMode = true;
      }
  })
}


//------------------------------------------------------
setEntity(assetOrder: AssetOrder) {
    this.assetOrder = { ...assetOrder };
}
getEntity(){
    return this.assetOrder;
}
//------------------------------------------------------

  //------------------------------------------------------
  saveRow() : Promise<AssetOrder>{
    return this.assetOrderService.assetOrderSave(this.assetOrder);
  }
  //------------------------------------------------------



addBarCode(assetOrderLine : AssetOrderLine){
  if (! assetOrderLine.serialNumber){
    this.toastr.error("N° Série vide");
    return;
  }

  assetOrderLine.serialNumber = assetOrderLine.serialNumber.trim();
  if (assetOrderLine.serialNumber == ""){
    this.toastr.error("N° Série vide");
    return;
  }

  if ( (this.leanUtilsService.serialNumberlength) &&  (assetOrderLine.serialNumber.length != this.leanUtilsService.serialNumberlength)) {
    this.toastr.error("Longueur du N° Série invalide");
    return;
  }

  if (assetOrderLine.serialNumbers.indexOf(assetOrderLine.serialNumber) >= 0){
    this.toastr.error("N° Série déjà scanné");
    return;
  }

  assetOrderLine.serialNumbers.push(assetOrderLine.serialNumber);
  assetOrderLine.serialNumber = null;
}

remove(assetOrderLine : AssetOrderLine, serialNumber : string){
  if (! assetOrderLine.serialNumbersToDelete) assetOrderLine.serialNumbersToDelete = [];
  assetOrderLine.serialNumbersToDelete.push(serialNumber);
  const index = assetOrderLine.serialNumbers.indexOf(serialNumber, 0);
  if (index > -1) {
    assetOrderLine.serialNumbers.splice(index, 1);
  }
}

register(){

let atLeastOneNonNull : boolean = false;

//---------------------------------------------------------------------------------------------------------------
  for (let assetOrderLine of this.assetOrder.assetOrderLines){
    if (assetOrderLine.serialNumbers.length > 0){
        atLeastOneNonNull  =  true;
    }
  }
//---------------------------------------------------------------------------------------------------------------
 
if (! atLeastOneNonNull) {
  this.toastr.error("Aucune quantité scannée !");
  return;
}

//---------------------------------------------------------------------------------------------------------------
  this.assetOrderService.assetOrderBufferize(this.assetOrder).then(res => {
      this.toastr.success("Opération effectuée avec succès !!!");
    })
//---------------------------------------------------------------------------------------------------------------
 
}

validate(){

  let atLeastOneNonNull : boolean = false;

//---------------------------------------------------------------------------------------------------------------
  for (let assetOrderLine of this.assetOrder.assetOrderLines){
    let expectedQuantity : number = assetOrderLine.expectedQuantity
    if (! expectedQuantity) {
      expectedQuantity = 0;
    }
    if (assetOrderLine.serialNumbers.length != expectedQuantity){
      this.toastr.error("La quantité scannée est différente de la quantité attendue pour : " + assetOrderLine.assetProduct.name);
      return;
    }
    if (assetOrderLine.serialNumbers.length > 0){
        atLeastOneNonNull  =  true;

    }
  }
//---------------------------------------------------------------------------------------------------------------
 
if (! atLeastOneNonNull) {
  this.toastr.error("Aucune quantité scannée !");
  return;
}

//---------------------------------------------------------------------------------------------------------------
  this.assetOrderService.assetOrderReception(this.assetOrder).then(assetOrder => {
    this.assetOrder = assetOrder;

      this.receptionMode = false;
      this.toastr.success("Opération effectuée avec succès !!!");

      /*
      if (assetTransferCode != null)  {
        this.toastr.success("Opération effectuée avec succès");
      } else {
      }
      */
    })
//---------------------------------------------------------------------------------------------------------------
 
}

  receptions(){
    this.router.navigate(['/dashboard/services/asset-transfer-list-mobile', {assetOrderCode : this.assetOrder.assetOrderCode, assetTransferType : AssetTransferType.Reception, direction : AssetTransferDirection.input}]);
  }

  startReception(){
    this.assetOrderService.assetOrderGet(this.assetOrder.assetOrderCode).then(assetOrder => {
        this.assetOrder = assetOrder;
        this.receptionMode = true;
        for (let assetOrderLine of this.assetOrder.assetOrderLines){
          if (!assetOrderLine.serialNumbers) assetOrderLine.serialNumbers = [];
          assetOrderLine.shrinkMode = false;
        }
      })
  }
  
  abortReception(){
    this.receptionMode = false;
    for (let assetOrderLine of this.assetOrder.assetOrderLines){
      assetOrderLine.serialNumbers = [];
      assetOrderLine.shrinkMode = true;
    }
  }

}
